/* Mobile product gallery: swipe, arrows and dots */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('media-gallery').forEach((gallery) => {
    const viewer = gallery.querySelector(
      'slider-component:first-of-type'
    );

    const mediaList = gallery.querySelector(
      '.product__media-list'
    );

    if (!viewer || !mediaList) return;

    if (viewer.querySelector('.iwc-mobile-gallery-dots')) return;

    const getVisibleItems = () =>
      Array.from(
        mediaList.querySelectorAll('.product__media-item')
      ).filter((item) => {
        return (
          !item.hidden &&
          window.getComputedStyle(item).display !== 'none'
        );
      });

    let currentIndex = 0;

    const previousButton = document.createElement('button');
    previousButton.type = 'button';
    previousButton.className =
      'iwc-mobile-gallery-arrow ' +
      'iwc-mobile-gallery-arrow--previous';
    previousButton.innerHTML = '&#8249;';
    previousButton.setAttribute(
      'aria-label',
      'View previous product image'
    );

    const nextButton = document.createElement('button');
    nextButton.type = 'button';
    nextButton.className =
      'iwc-mobile-gallery-arrow ' +
      'iwc-mobile-gallery-arrow--next';
    nextButton.innerHTML = '&#8250;';
    nextButton.setAttribute(
      'aria-label',
      'View next product image'
    );

    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'iwc-mobile-gallery-dots';

    function getItems() {
      return getVisibleItems();
    }

    function createDots() {
      dotsContainer.innerHTML = '';

      getItems().forEach((item, index) => {
        const dot = document.createElement('button');

        dot.type = 'button';
        dot.className = 'iwc-mobile-gallery-dot';
        dot.setAttribute(
          'aria-label',
          `View product image ${index + 1}`
        );

        dot.addEventListener('click', () => {
          goToImage(index);
        });

        dotsContainer.appendChild(dot);
      });

      updateControls();
    }

    function goToImage(index) {
      const items = getItems();

      if (!items.length) return;

      currentIndex =
        ((index % items.length) + items.length) %
        items.length;

      const selectedItem = items[currentIndex];

      mediaList.scrollTo({
        left: selectedItem.offsetLeft,
        behavior: 'smooth'
      });

      updateControls();
    }

    function calculateCurrentIndex() {
      const items = getItems();

      if (!items.length) return 0;

      const galleryCentre =
        mediaList.scrollLeft + mediaList.clientWidth / 2;

      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      items.forEach((item, index) => {
        const itemCentre =
          item.offsetLeft + item.offsetWidth / 2;

        const distance = Math.abs(
          galleryCentre - itemCentre
        );

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function updateControls() {
      const dots = Array.from(
        dotsContainer.querySelectorAll(
          '.iwc-mobile-gallery-dot'
        )
      );

      dots.forEach((dot, index) => {
        dot.classList.toggle(
          'is-active',
          index === currentIndex
        );

        dot.setAttribute(
          'aria-current',
          index === currentIndex ? 'true' : 'false'
        );
      });

      const hasMultipleImages = getItems().length > 1;

      previousButton.hidden = !hasMultipleImages;
      nextButton.hidden = !hasMultipleImages;
      dotsContainer.hidden = !hasMultipleImages;
    }

    previousButton.addEventListener('click', () => {
      goToImage(currentIndex - 1);
    });

    nextButton.addEventListener('click', () => {
      goToImage(currentIndex + 1);
    });

    let scrollFrame;

    mediaList.addEventListener(
      'scroll',
      () => {
        window.cancelAnimationFrame(scrollFrame);

        scrollFrame = window.requestAnimationFrame(() => {
          currentIndex = calculateCurrentIndex();
          updateControls();
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', () => {
      currentIndex = calculateCurrentIndex();
      updateControls();
    });

    viewer.appendChild(previousButton);
    viewer.appendChild(nextButton);
    viewer.appendChild(dotsContainer);

    createDots();

    const galleryObserver = new MutationObserver(() => {
      createDots();
      currentIndex = calculateCurrentIndex();
      updateControls();
    });

    galleryObserver.observe(mediaList, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden']
    });
  });
});